import { PropsWithChildren } from "react";
import "./AppMainHeader.scss";

export type LogoItem = {
  src: string;
  label: string;
};

interface AppHeaderLogoAndMainNavProps extends PropsWithChildren {
  logos: [LogoItem?, LogoItem?];
}

export const AppHeaderLogoAndMainNav: React.FC<
  AppHeaderLogoAndMainNavProps
> = ({ children, logos = [] }) => {
  return (
    <div className="app-header-left">
      <div className="logos-container">
        {logos.map((logo) => (
          <div className="logo-menu-container" key={logo!.src}>
            <a
              className="logo-link"
              href={"/"}
              target="_self"
              aria-label={logo!.label}
            >
              <div
                className={"logo-container"}
                style={{ backgroundImage: `url("${logo!.src}")` }}
              />
            </a>
          </div>
        ))}
      </div>
      {children}
    </div>
  );
};

export const AppHeaderSecondaryNav = ({ children }: PropsWithChildren<{}>) => {
  return <div className="app-header-right">{children}</div>;
};

interface AppMainHeaderProps extends PropsWithChildren<{}> {
  className?: string;
  dataTestId?: string;
}

const AppMainHeader = ({
  children,
  className = "",
  dataTestId,
}: AppMainHeaderProps) => {
  return (
    <div
      className={`app-header-wrapper ${className}`}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
};

export default AppMainHeader;
